import { Box } from '@mui/material';
import React from 'react';

import { DarkCloudA } from '../_assets/DarkCloudA.tsx';
import { DarkCloudB } from '../_assets/DarkCloudB.tsx';
import { CTA } from '../_components/CTA.tsx';
import { Section } from '../_components/Section.tsx';
import { StatsCard } from '../_components/StatsCard.tsx';

export type StatsSectionProps = {
  // Empty
};

export const StatsSection: React.FC<StatsSectionProps> = () => {
  return (
    <Section
      sx={{
        gap: { xs: '60px', lg: '120px' },
        flexDirection: { md: 'row' },
        alignItems: { md: 'center' },
        maxWidth: '1280px',
        position: 'relative',
        isolation: 'isolate',
      }}
    >
      <DarkCloudA
        sx={{
          position: 'absolute',
          zIndex: -1,
          width: { xs: 60, sm: 70, md: 80, lg: 100 },
          top: { xs: -20, md: -50 },
          left: { xs: 50, sm: '10%', lg: '20%' },
        }}
      />
      <DarkCloudB
        sx={{
          position: 'absolute',
          zIndex: -1,
          width: { xs: 110, sm: 120, md: 130, lg: 150 },
          top: { xs: 0, md: 20 },
          right: { xs: 30, sm: '10%' },
        }}
      />

      <Box sx={{ order: { md: 1 }, flex: 5 }}>
        <div className="mb-8 typography-v1-h1">
          Vi ønsker at enda flere skal få lavere rente på sin forbruks- og kredittkortgjeld
        </div>
        <CTA />
      </Box>
      <StatsCard sx={{ flex: 4 }} />

      <DarkCloudA
        sx={{
          position: 'absolute',
          zIndex: -1,
          display: { xs: 'none', md: 'initial' },
          width: { md: 80, lg: 90 },
          bottom: { md: 50 },
          right: { md: '20%' },
        }}
      />
    </Section>
  );
};
